import { ThunkAction } from 'redux-thunk';
import { ISignInState } from '@telstra-connect/login/state';
import { get } from '@telstra-connect/utils/http';
import {
    loadOrderProductDetailsError,
    loadOrderProductDetailsReset,
    loadOrderProductDetailsStart,
    loadOrderProductDetailsSuccess,
} from '../../../actions/load-order-product-details';
import { IOrderDetails } from '../../../../../applications/order-tracker/config/order-tracker-new-common/types';
import { formatOrderSummaryResponse, isSourceMpex, OrderTrackerV3BaseUrl } from '..';
import { IOrderDetailsStateResponse } from '@telstra-connect/order-tracker/state/order-details';
import { OrderSource } from '@telstra-connect/mobility-pex/type';

export function loadOrderProductDetails(
    orderNumber: string,
    cidn: string
): ThunkAction<void, ISignInState, void> {
    return (dispatch, getState) => {
        const url: string = `${OrderTrackerV3BaseUrl}/details/${encodeURIComponent(
            orderNumber
        )}`;
        dispatch(loadOrderProductDetailsStart());
        return get<IOrderDetailsStateResponse>({
            url,
            customHeaders: {
                'company-id': cidn,
            },
            state: getState(),
        })
            .then((result) => {
                if (isSourceMpex(result.sourceSystem)) {
                    dispatch(loadOrderProductDetailsSuccess({
                        sourceSystem: result.sourceSystem
                    }));
                // TODO: Need to remove this validation
                } else if (isInvalidResponse(result.orderSummary)) {
                    dispatch(loadOrderProductDetailsError('Mandatory field data not available'));
                } else {
                    dispatch(loadOrderProductDetailsSuccess(formatOrderSummaryResponse(result)));
                }
            })
            .catch((error) => {
                dispatch(
                    loadOrderProductDetailsError(
                        `Error fetching order details from ${url}`
                    )
                );
            });
    };
}

export function skipOrderDetailsForMpex(): ThunkAction<void, ISignInState, void> {
    return (dispatch) => {
        dispatch(loadOrderProductDetailsSuccess({
            sourceSystem: OrderSource.mpex.toUpperCase()
        }));
    }
}

export function resetOrderDetails(): ThunkAction<void, ISignInState, void> {
    return (dispatch) => {
        dispatch(loadOrderProductDetailsReset())
    }
}

const isInvalidResponse = (orderSummary: IOrderDetails): boolean => {
    if (!orderSummary?.products) {
        return true;
    }
    return orderSummary.products.some(
        (product) =>
            !product.status ||
            !product.productProgress ||
            !product.productOrderNumber ||
            !product.productName
    );
};
